import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// mui imports
import { Container, Grid, Box, useMediaQuery, Breadcrumbs, Typography } from '@mui/material';
import logo from '../../assets/images/logos/Main-Logo_Dashboard.svg';
import HomeIcon from '@mui/icons-material/Home';
import login_bg from '../../assets/images/logos/Dashboard_Background.png';
import { UserIconButton } from '../../components/Header/HeaderComponent';
import { fetchExerciseByCourseIdAsync } from 'store/actions';
import { baseURLs } from 'utils/baseURLs';
import { useDispatch } from 'react-redux';
// CKey-112: Hide Navigation & Session Gaurd
import useBlockNavigation  from "./useBlockNavigation";
import useSessionGaurd from "./useSessionGaurd";
import Link from '@mui/material/Link'

const TypingLayout = () => {
  // CKey-112: use Session Gaurd
  useSessionGaurd();
  // CKey-112: Hide Navigation
  useBlockNavigation(); 
  const navenable = sessionStorage.getItem('navigation') === 'true';
  const matches = useMediaQuery('(min-width:600px)');

  const HeaderComp = () => {
    const navigate = useNavigate();
    useEffect(() => {
      if (sessionStorage.getItem('username') == null) {
        navigate('/login');
      }
    });
    return (
      <Box
        container
        sx={{
          py: 1,
          bgcolor: `#f7f9fc`,
          boxShadow: ` 0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%)`,
          backgroundImage: `url(${login_bg}) !important`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover !important',
          backgroundPosition: 'top top',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
        <img
          src={logo}
          // CKey-112: Hide Navigation
          // onClick={() => navigate('/dashboard')}
          onClick={navenable ? () => navigate('/dashboard') : undefined}
          style={{ marginLeft: 84, height: matches ? 40 : 40, width: matches ? '' : '200px' }}
        />
        <UserIconButton />
      </Box>
    );
  };
  /* breadcumb */
  const BreadcumbBar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const fetchExercises = async (iditem, sessionId, sessionName) => {
      localStorage.setItem('courseIdselected', iditem);
      await dispatch(fetchExerciseByCourseIdAsync(baseURLs.core_course_get_contents + iditem +'&options[0][name]=modname&options[0][value]=kb'))
        .unwrap()
        .then(res => {
          if (Array.isArray(res)) {
            const matchingObjects = res.map(item => (item.id == sessionId ? item.modules : null)).filter(modules => modules !== null && modules.length > 0);
            navigate(prevPath, {
              state: {
                modules: matchingObjects[0],
                session: sessionName,
                courseID: iditem,
                links: `${matchingObjects[0]}-${iditem}`
              }
            });
          }
        })
        .catch(err => console.log(err));
    };
    const pathFirstSegment = location.pathname?.split('/').filter(x => x)[0];
    const session = location.state?.session;
    const lastSegment = location.pathname?.split('/').filter(Boolean).pop();
    const cleanString = decodeURIComponent(lastSegment).replace(/_/g, ' ');
    const prevPath = sessionStorage.getItem('pathnameForPrev');
    const prevPathLastSegment = prevPath ? prevPath?.split('/').filter(Boolean).pop() : null;
    const prevSession = sessionStorage.getItem('sessionForPrev');
    const prevSessiontrim = prevSession !== session ? prevSession?.split(':')[0]?.trim() : '';
    const capitalizedSegment = pathFirstSegment.charAt(0).toUpperCase() + pathFirstSegment.slice(1);

    // Combine the first segment with the session name
    const pathnames = [];
    if (pathFirstSegment) pathnames.push(capitalizedSegment);
    if (prevSessiontrim) pathnames.push(prevSessiontrim);
    if (lastSegment) pathnames.push(cleanString);

    const handleBreadcrumbClick = index => {
      if (index === 0) {
        // Navigate to /pathFirstSegment
        navigate(`/${pathFirstSegment}`);
      } else if (index === 1 && prevPath) {
        fetchExercises(location.state?.courseID, prevPathLastSegment, prevSession);
      }
    };
    // CKey-112
     if (!navenable) {
        return (
          <Box
            sx={{
              bgcolor: '#ffffff',
              boxShadow: `0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%)`,
              m: 0,
              p: 2, 
              display: 'flex',
              justifyContent: 'flex-start'
            }}
          >
            <Link
              component="button"
              underline="hover"
              onClick={() => navigate('/report-access')}
              sx={{
                fontWeight: 'bold',
                cursor: 'pointer',
                pl: '100px'
              }}
            >
              View Reports
            </Link>
          </Box>
          );
    }
    /* CKey-112: Hiding Navigation */
    return ( navenable && 
      <Box
        sx={{
          bgcolor: '#ffffff',
          boxShadow: `0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%)`,
          m: 0
        }}>
        <Box sx={{ ml: 10, display: 'flex', alignItems: 'center' }}>
          <HomeIcon
            onClick={() => navigate('/dashboard')}
            fontSize="medium"
            sx={{ mb: 0, mt: 0.3, cursor: 'pointer', color: '#124c72 !important' }}
          />
          <Typography
            sx={{
              mx: 1, // Add horizontal margin
              fontSize: 'medium',
              fontWeight: 'bold',
              color: '#124c72'
            }}>
            /
          </Typography>
          <Breadcrumbs>
            {pathnames.map((value, index) => {
              const last = index === pathnames.length - 1;
              const var1 = value.split('-');
              return last ? (
                <Typography
                  sx={{
                    fontSize: 'medium',
                    paddingLeft: '3px',
                    fontWeight: '100 !important',
                    color: '#grey !important'
                  }}
                  fontSize="medium"
                  color="textPrimary"
                  onClick={() => handleBreadcrumbClick(index)}
                  key={index}>
                  {var1[0].replace(/_/g, ' ')}
                </Typography>
              ) : (
                <Typography
                  sx={{
                    cursor: 'pointer',
                    fontSize: 'medium',
                    paddingLeft: '3px',
                    color: '#124c72 !important'
                  }}
                  color="inherit"
                  onClick={() => handleBreadcrumbClick(index)}
                  key={index}>
                  {var1[0].replace(/_/g, ' ')}
                </Typography>
              );
            })}
          </Breadcrumbs>
        </Box>
      </Box>
    );
  };

  const HeaderComponentDiv = () => {
    return (
      <div
        style={{
          position: 'sticky',
          top: '0',
          width: '100%',
          zIndex: 1000
        }}>
        <HeaderComp />
        <BreadcumbBar />
      </div>
    );
  };
  return (
    <Container
      disableGutters={true}
      sx={{
        p: 0,
        margin: '0',
        maxWidth: '100vw !important'
      }}>
      <HeaderComponentDiv />
      <Grid
        container
        columns={12}
        sx={{
          py: 1.5
        }}>
        <Grid item xs={12} lg={12} sx={{ backgroundColor: '#ffffff' }}>
          <Outlet />
        </Grid>
      </Grid>
    </Container>
  );
};
export default TypingLayout;
